import { HttpClient, HttpParams } from "@angular/common/http";
import { Inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { Field, SearchItem, SearchResults } from "../common/common.model";
import { IServiceInterface } from "../common/feltside/feltside.component";
//import { Server } from "../koblinger/koblinger.service";


@Injectable({
  providedIn: "root"
})
export class ServereService implements IServiceInterface<Server> {

  private readonly basePath = "api/server/";
  private readonly baseUrl: string;

  constructor(private http: HttpClient, @Inject("BASE_URL") private baseHost: string) {
    this.baseUrl = baseHost + this.basePath;
  }

  search(beskrivelse: string, sortOrder: string, pageNumber: number, pageSize: number, hasSystem?: boolean): Observable<ServerSearchResult> {
    let searchParams = new HttpParams();

    if (beskrivelse) { searchParams = searchParams.append("beskrivelse", beskrivelse); }
    if (sortOrder) { searchParams = searchParams.append("sortOrder", sortOrder); }
    searchParams = searchParams.append("pageNumber", pageNumber.toString());
    searchParams = searchParams.append("pageSize", pageSize.toString());


    if (hasSystem !== null && hasSystem !== undefined) {
      searchParams = searchParams.append("hasSystem", hasSystem.toString());
    }

    return this.http.get<ServerSearchResult>(this.baseUrl, { params: searchParams });
  }

  get(serverId: number): Observable<Server> {
    return this.http.get<Server>(this.baseUrl + serverId);
  }

  put(server: Server): Observable<Server> {
    return this.http.put<Server>(this.baseUrl + server.serverId, server);
  }

  post(server: Server): Observable<Server> {
    return this.http.post<Server>(this.baseUrl, server);
  }

  getFields(serverId: number): Observable<Field[]> {
    return this.http.get<Field[]>(this.baseUrl + serverId + "/fields");
  }
  /*
  getCreateFields(id?: number): Observable<Field[]> {
    throw new Error("Method not implemented.");
  }
  */
  getCreateFields(): Observable<Field[]> {
    return this.http.get<Field[]>(this.baseUrl + "create/fields");
  }

}

export interface Server {
  serverId: number;
  navn: string;
  systemCount: number;
}

export interface ServerSearchResult {
  pageNumber: number;
  numberOfHits: number;
  totalPages: number;
  items: Server[];
}
